import React, { useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Close from "@material-ui/icons/Close";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Switch from "@material-ui/core/Switch";
import GetApp from "@material-ui/icons/GetApp";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";

import { localApi } from "utils/imgApi";
import Slide from "@material-ui/core/Slide";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import styleDailog from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import styRadio from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import styCheckbox from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import stylesTog from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";

import { credentials } from "utils/imgApi";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

const useStyles = makeStyles(styles);
const useStyleDailog = makeStyles(styleDailog);
const useStyle = makeStyles(styRadio);
const useSty = makeStyles(styCheckbox);
const useStylesTog = makeStyles(stylesTog);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

export default function ViewPostsList() {
  const [postCallWhatsAppList, setPostCallWhatsAppList] = React.useState([]);

  const [postsID, setPostsId] = React.useState("");

  const [postRows, setPostRows] = React.useState([]);

  const [checkedRows, setCheckedRows] = React.useState({});

  const [currentPage, setCurrentPage] = React.useState(0);
  const [currentRows, setCurrentRows] = React.useState(10);

  const classes = useStyles();
  const classeDailog = useStyleDailog();
  const classesRadio = useStyle();
  const classCheck = useSty();
  const classesTog = useStylesTog();

  const history = useHistory();
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));
  const { state } = useLocation();

  // console.log(state);

  if (state === null) {
    history.push("/admin/view-posts");
  }

  /*
   * Convert API active value to true/false.
   */
  const isActiveValue = (active) => {
    return (
      active === true || active === 1 || active === "1" || active === "true"
    );
  };

  /*
   * Get data from API.
   */
  async function getSets() {
    const api =
      localApi +
      `/posts/allListCall/byAdminAndPostsId/${state.id}/${userObj.id}`;

    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });

    const getResult = await result.json();

    // console.log("Post Call List:", getResult);

    // Make sure response is an array
    if (Array.isArray(getResult)) {
      const initialCheckedRows = {};

      getResult.forEach((item, index) => {
        const rowId = item.id ?? item.mobile ?? index;

        initialCheckedRows[rowId] = isActiveValue(item.active);
      });

      setCheckedRows(initialCheckedRows);

      const updatedList = await Promise.all(
        getResult.map(async (item) => {
          try {
            const apiR = localApi + `/register/byMobile/${item.mobile}`;

            const resultR = await fetch(apiR, {
              method: "GET",
              headers: {
                Authorization: `Basic ${credentials}`,
              },
            });

            const getRes = await resultR.json();

            // console.log("Register Data:", getRes);

            return {
              ...item,

              // Change whatsapp field name according to your API response
              whatsapp: getRes?.whatsapp || "",
            };
          } catch (error) {
            console.error(
              `Error getting WhatsApp for mobile ${item.mobile}:`,
              error,
            );

            return {
              ...item,
              whatsapp: "",
            };
          }
        }),
      );

      // console.log("Final List:", updatedList);

      if (updatedList.length === 0) {
        history.push("/admin/view-posts");
        return;
      }

      setPostRows(updatedList);
    }
  }

  /*
   * Load API data once.
   */
  useEffect(() => {
    if (state !== null) {
      getSets();
    }
  }, []);

  useEffect(() => {
    if (!Array.isArray(postRows)) {
      return;
    }

    setPostCallWhatsAppList(
      postRows.map((or, key) => {
        const rowId = or.id ?? or.mobile ?? key;

        const isActive =
          checkedRows[rowId] !== undefined
            ? checkedRows[rowId]
            : isActiveValue(or.active);

        return {
          sino: key + 1,

          date: or.createdAt ? or.createdAt.slice(0, -19) : "",

          company: (or.company || "") + ", " + (or.firstname || ""),

          mobile: or.mobile,

          whatsapp: or.whatsapp ? (
            <span
              onClick={() => {
                const whatsappNumber = String(or.whatsapp).replace(/\D/g, "");

                if (whatsappNumber) {
                  window.open(
                    `https://wa.me/${whatsappNumber}`,
                    "_blank",
                    "noopener,noreferrer",
                  );
                }
              }}
              style={{
                color: "#25D366",
                cursor: "pointer",
                fontWeight: "500",
                textDecoration: "underline",
              }}
            >
              {or.whatsapp}
            </span>
          ) : (
            ""
          ),

          actions: (
            <div className="actions-right">
              <div
                className={
                  classesRadio.checkboxAndRadio +
                  " " +
                  classesRadio.checkboxAndRadioHorizontal
                }
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={isActive}
                      onChange={async (event) => {
                        const checked = event.target.checked;

                        const payload = {
                          active: checked,
                        };

                        try {
                          const response = await fetch(
                            `${localApi}/posts/update/postCallsById/${rowId}`,
                            {
                              method: "PUT",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `Basic ${credentials}`,
                              },
                              body: JSON.stringify(payload),
                            },
                          );

                          const data = await response.json();

                          // console.log("Update Response:", data);

                          if (
                            data?.message === "Data Updated Successfully !!!"
                          ) {
                            await getSets();

                            return;
                          }

                          console.error("Active status update failed:", data);
                        } catch (error) {
                          console.error("Error updating active status:", error);
                        }
                      }}
                      value={rowId}
                      classes={{
                        switchBase: classesTog.switchBase,
                        checked: classesTog.switchChecked,
                        thumb: classesTog.switchIcon,
                        track: classesTog.switchBar,
                      }}
                    />
                  }
                  classes={{
                    label: classesTog.label,
                  }}
                  label={isActive ? "Toggle is on" : "Toggle is off"}
                />
              </div>
            </div>
          ),
        };
      }),
    );
  }, [postRows, checkedRows, classesRadio, classesTog]);

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            {/* <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>

              <h4 className={classes.cardIconTitle}>Posts Call List</h4>
            </CardHeader> */}

            <CardHeader
              color="rose"
              icon
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <CardIcon color="rose">
                  <Assignment />
                </CardIcon>

                <h4
                  className={classes.cardIconTitle}
                  style={{ marginLeft: "10px", marginBottom: 0 }}
                >
                  Posts Call List
                </h4>
              </div>
              <Button
                color="rose"
                simple
                // justIcon
                size="sm"
                onClick={() => {
                  const url =
                    localApi +
                    `/posts/list/byAdminIdAndPostCallsReportPdfDownload/${userObj.id}/0`;

                  window.open(url, "_blank"); // Opens in new tab
                }}
              >
                <PictureAsPdf />
              </Button>
            </CardHeader>

            <CardBody>
              {/*
               * Horizontal scroll for mobile, tablet and desktop.
               * Table will keep its minimum width instead of squeezing
               * all columns into a small screen.
               */}
              <div
                style={{
                  width: "100%",
                  overflowX: "auto",
                  overflowY: "hidden",
                  WebkitOverflowScrolling: "touch",
                }}
              >
                <div
                  style={{
                    minWidth: "950px",
                    width: "100%",
                  }}
                >
                  <ReactTable
                    columns={[
                      {
                        Header: "SI.No.",
                        accessor: "sino",
                      },
                      {
                        Header: "Date",
                        accessor: "date",
                      },
                      {
                        Header: "Company",
                        accessor: "company",
                      },
                      {
                        Header: "Mobile",
                        accessor: "mobile",
                      },
                      {
                        Header: "WhatsApp",
                        accessor: "whatsapp",
                      },
                      {
                        Header: "Actions",
                        accessor: "actions",
                      },
                    ]}
                    data={postCallWhatsAppList}
                    page={currentPage}
                    rows={currentRows}
                    onPageChange={(page) => {
                      // console.log(page);
                      setCurrentPage(page);
                    }}
                    onRowsChange={(rows) => {
                      // console.log(rows);
                      setCurrentRows(rows);
                    }}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
